

























import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import routerExceptionHandler from '../../includes/RouterExceptionHandler'

@Component
export default class SidebarHeader extends Vue {
  @Prop({ type: Boolean, required: true }) sidebarCollapsed!: boolean

  @Emit('triggerClick')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  triggerClick(): void {}

  get applicationName(): string {
    return this.$store.state.AdminTemplate.applicationConfig.meta.projectName
  }

  get applicationSidebarLogo(): string {
    return this.$store.state.AdminTemplate.applicationConfig.meta.sidebarLogo
  }

  gotoMainPage() {
    this.$router.push({ path: '/' }).catch(routerExceptionHandler)
  }

  created():void {
    this.$i18n.mergeLocaleMessage('ru', {
      close_sidebar: 'Закрыть меню',
      open_sidebar: 'Открыть меню',
    })
    this.$i18n.mergeLocaleMessage('en', {
      close_sidebar: 'Close menu',
      open_sidebar: 'Open menu',
    })

  }
}
